module.exports = __webpack_public_path__ + "static/CostofTransport-01d42101c160b255c7744a717de8bea7.png";